import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { shouldNotForwardProp } from '@ori/presentation-utils';
import { IconButton } from '@ori-ui/components';
import { styled } from '@ori-ui/mui';
import { ICON_BUTTON_PHONE_SIZE, ICON_BUTTON_SIZE } from "../../common";
export var IconRoot = styled(IconButton, {
  name: 'IconRoot',
  shouldForwardProp: shouldNotForwardProp(['smallerOnMobile'])
})(function (_ref) {
  var smallerOnMobile = _ref.smallerOnMobile,
    theme = _ref.theme;
  return _defineProperty({
    alignSelf: 'center',
    color: theme.palette.text.primary,
    display: 'flex',
    height: smallerOnMobile ? ICON_BUTTON_PHONE_SIZE : ICON_BUTTON_SIZE,
    justifyContent: 'center',
    width: smallerOnMobile ? ICON_BUTTON_PHONE_SIZE : ICON_BUTTON_SIZE,
    '& svg': {
      fontSize: smallerOnMobile ? theme.typography.pxToRem(21) : theme.typography.pxToRem(27),
      fill: theme.palette.text.primary
    },
    '.MuiSvgIcon-root': {
      display: 'inline-block'
    },
    // eslint-disable-next-line @typescript-eslint/naming-convention -- needed for CSS
    '@keyframes dash': {
      to: {
        strokeDashoffset: 0
      }
    },
    // eslint-disable-next-line @typescript-eslint/naming-convention -- needed for CSS
    '@keyframes rotating': {
      from: {
        transform: 'rotate(0)'
      },
      to: {
        transform: 'rotate(360deg)'
      }
    },
    '.outlinedIcon': {
      display: 'flex'
    },
    '.filledIcon': {
      display: 'none'
    },
    '&:hover': {
      color: theme.palette.text.secondary,
      '& svg': {
        fill: theme.palette.text.secondary
      },
      '.outlinedIcon': {
        display: 'none'
      },
      '.filledIcon': {
        display: 'flex'
      }
    }
  }, theme.breakpoints.up('sm'), {
    height: ICON_BUTTON_SIZE,
    width: ICON_BUTTON_SIZE,
    '& svg': {
      fontSize: '28px'
    }
  });
});
//# sourceMappingURL=styles.js.map